import "./Members.css";
import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import { BarLoader } from "react-spinners";
import { BaseURL } from "../../../Hooks/URL";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TextFieldInput from "../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { styled } from "@mui/material/styles";
import { images } from "../../../Assets/assetsHelper";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Filter from "../../../Components/Molecules/Filter/Filter";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import axios from "axios";
import { useCookies } from "react-cookie";
import { Box } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import { Pagination } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--primary)",
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  {
    id: "name",
    label: "Member Name",
    minWidth: 100,
  },
  {
    id: "birthday",
    label: "Birthday",
    minWidth: 100,
  },
  {
    id: "age",
    label: "Age",
    minWidth: 100,
  },
  // {
  //   id: "nationalId",
  //   label: "National ID",
  //   minWidth: 100,
  // },
  {
    id: "team",
    label: "Team",
    minWidth: 100,
  },
  {
    id: "account",
    label: "Account Code",
    minWidth: 100,
  },
  {
    id: "account",
    label: "Discount Percentage",
    minWidth: 100,
    discount: true,
  },
  {
    id: "account",
    label: "Paid",
    minWidth: 100,
    paid: true,
  },
];

function Members({
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  searchData,
  search,
  setSearchData,
  setSearch,
  members,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  membersNumber,
  setPage,
  sortBy,
  sortOrder,
  handleSortChange,
  handleSortOrderChange,
  filters,
  handleFilterChange,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [showFilters, setShowFilters] = useState(!isMobile);
  const [discountPercentage, setDiscountPercentage] = useState("");

  return (
    <div className="mainContainer">
      <div className="cont">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>Total Members: {membersNumber}</h2>
          <a
            href={`${BaseURL}/admin/dashboard/members/excel?${
              sortBy ? `&sortBy=${sortBy}` : ""
            }${sortOrder ? `&sortDesc=${sortOrder}` : ""}${
              search ? `&search=${search}` : ""
            }&timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`}
            target="_blank"
          >
            <PrimaryButton
              classBtn={"center editButton"}
              text={"Download Excel"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "var(--text-primary)",
                height: "40px",
                padding: "0 30px",
                fontSize: "15px",
              }}
            />
          </a>
        </Box>

        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {isMobile && (
            <IconButton
              onClick={() => setShowFilters(!showFilters)}
              sx={{
                backgroundColor: "var(--primary)",
                color: "white",
                "&:hover": {
                  backgroundColor: "#8a0505",
                },
              }}
            >
              <FilterListIcon />
            </IconButton>
          )}
        </Box>

        <Collapse in={showFilters}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={3}>
              <TextFieldInput
                searchIcon={true}
                Required={false}
                type="text"
                placeholder={"Search"}
                className="SearchBar"
                name={"search"}
                change={(e) => setSearchData(e.target.value)}
                newValue={searchData}
                searchAction={() => {
                  if (search != searchData) {
                    setSearch(searchData);
                    setPage(0);
                  }
                }}
                keyDown={(e) => {
                  if (e.keyCode === 13)
                    if (search != searchData) {
                      setSearch(searchData);
                      setPage(0);
                    }
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sortBy}
                  label="Sort By"
                  onChange={handleSortChange}
                  defaultValue={sortBy}
                >
                  {[
                    { id: "name", label: "Member Name" },
                    { id: "teamName", label: "Team Name" },
                    { id: "accountCode", label: "Account Code" },
                    { id: "discountPercentage", label: "Discount Percentage" },
                  ].map((column) => (
                    <MenuItem key={column.id} value={column.id}>
                      {column.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Order</InputLabel>
                <Select
                  value={sortOrder}
                  label="Order"
                  onChange={handleSortOrderChange}
                >
                  <MenuItem value={false}>
                    {sortBy == "name" || sortBy == "teamName"
                      ? "A-Z"
                      : "Lowest to Highest"}
                  </MenuItem>
                  <MenuItem value={true}>
                    {sortBy == "name" || sortBy == "teamName"
                      ? "Z-A"
                      : "Highest to Lowest"}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Account Paid</InputLabel>
                <Select
                  value={filters?.accountPaid}
                  label="Account Paid"
                  name="accountPaid"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Competition Type</InputLabel>
                <Select
                  value={filters?.competitionType}
                  label="Competition Type"
                  name="competitionType"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="online">Online</MenuItem>
                  <MenuItem value="onlineOnly">Online Only</MenuItem>
                  <MenuItem value="offline">Offline</MenuItem>
                  <MenuItem value="offlineOnly">Offline Only</MenuItem>
                  <MenuItem value="both">Both</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Has Discount</InputLabel>
                <Select
                  value={filters?.hasDiscount}
                  label="Has Discount"
                  name="hasDiscount"
                  onChange={handleFilterChange}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextFieldInput
                searchIcon={true}
                Required={false}
                type="text"
                placeholder={"Discount Percentage"}
                className="SearchBar"
                name={"discountPercentage"}
                change={(e) => setDiscountPercentage(e.target.value)}
                newValue={discountPercentage}
                searchAction={() =>
                  handleFilterChange({
                    target: {
                      name: "discountPercentage",
                      value: discountPercentage,
                    },
                  })
                }
                keyDown={(e) => {
                  if (e.keyCode === 13)
                    handleFilterChange({
                      target: {
                        name: "discountPercentage",
                        value: discountPercentage,
                      },
                    });
                }}
              />
            </Grid>
          </Grid>
        </Collapse>

        <Paper
          className="tableCont"
          sx={{ width: "fit-content", minWidth: "100%" }}
        >
          {members && !loading ? (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                          }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {members?.map((member, i) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={member.id}
                          style={{ cursor: "pointer" }}
                        >
                          {columns.map((column) => {
                            const value = member[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ padding: "10px" }}
                              >
                                {column.id == "birthday" ? (
                                  value?.split("T")?.at(0)
                                ) : column.id == "team" ? (
                                  <span
                                    style={{ textDecoration: "underline" }}
                                    onClick={() =>
                                      navigate(`/teams/${value?.id}`)
                                    }
                                  >
                                    {value?.name}
                                  </span>
                                ) : column.id == "account" &&
                                  column.discount ? (
                                  value?.discountPercentage ? (
                                    `${value?.discountPercentage}%`
                                  ) : (
                                    "-"
                                  )
                                ) : column.id == "account" && column.paid ? (
                                  value?.paid ? (
                                    <DoneIcon className="activatedTick" />
                                  ) : (
                                    <CloseIcon className="NonActivatedTick" />
                                  )
                                ) : column.id == "account" ? (
                                  <span
                                    style={{ textDecoration: "underline" }}
                                    onClick={() =>
                                      navigate(`/accounts/${value?.id}`)
                                    }
                                  >
                                    {value?.code}
                                  </span>
                                ) : column.id == "account" &&
                                  column.discount ? (
                                  value ? (
                                    `${value}%`
                                  ) : (
                                    "-"
                                  )
                                ) : (
                                  value ?? "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                {!members?.length ? (
                  <h3 style={{ textAlign: "center", margin: "50px" }}>
                    No Members Added Yet!!
                  </h3>
                ) : (
                  ""
                )}
              </TableContainer>
              <Pagination
                count={pageCount}
                page={page + 1}
                onChange={handleChangePage}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "0 20px`",
                  padding: "20px",
                  color: "var(--primary)",
                  "& .Mui-selected": {
                    backgroundColor: "var(--primary)",
                    color: "white",
                  },
                }}
              />
            </>
          ) : (
            <div className="loadingBox">
              <BarLoader color="var(--primary)" />
            </div>
          )}
        </Paper>
      </div>
    </div>
  );
}

export default Members;
